import { render, staticRenderFns } from "./AsnDetail.vue?vue&type=template&id=6aeeab96&scoped=true&"
import script from "./AsnDetail.vue?vue&type=script&lang=js&"
export * from "./AsnDetail.vue?vue&type=script&lang=js&"
import style0 from "./AsnDetail.vue?vue&type=style&index=0&id=6aeeab96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeeab96",
  null
  
)

export default component.exports